

import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";

@Component({})
export default class ShowDeletedButton extends Vue {

  @Prop()
  protected showDeleted!: boolean;

  protected onClick() {
    this.$emit('click');
  }

}

